import {
  DialogContent,
  DialogActions,
  Button,
  Dialog,
  DialogProps,
  Box,
  colors,
  useTheme,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useEffect, useRef, useState } from "react";
import LegendComponent from "./LegendComponent";
import {
  AirplanemodeActive,
  PunchClock,
  StackedBarChart,
  Timeline,
} from "@mui/icons-material";
import { tokens } from "../../../../core/AppStyles";
import { useTranslation } from "react-i18next";

const ModalDashboardLegend = () => {
  const [open, setOpen] = useState(false);
  const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
  const { t } = useTranslation();
  const theme = useTheme();
  const customColors = tokens(theme.palette.mode);

  const handleClickOpen = (scrollType: DialogProps["scroll"]) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = useRef<HTMLElement>(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  });

  return (
    <div style={{ width: "45%" }}>
      <Button onClick={handleClickOpen("paper")}>
        <InfoIcon />
      </Button>
      <Dialog
        PaperProps={{ style: { background: customColors.component } }}
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        style={{ width: "auto" }}
      >
        <DialogContent
          dividers={scroll === "paper"}
          sx={{
            width: "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "60vh",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
            }}
          >
            <p
              style={{
                width: "100%",
                textAlign: "justify",
                height: "auto",
                padding: "2%",
              }}
            >
              {t("DASHBOARD.LEGEND.TITLE")}
            </p>
            <LegendComponent
              icon={<PunchClock />}
              title={t("DASHBOARD.LEGEND.MONTHLY_WORKING_HOURS.TITLE")}
              description={t(
                "DASHBOARD.LEGEND.MONTHLY_WORKING_HOURS.DESCRIPTION"
              )}
              backgroundColor={colors.blue[50]}
            />
            <LegendComponent
              title={t("DASHBOARD.LEGEND.TODAY_WORKING_HOURS.TITLE")}
              description={t(
                "DASHBOARD.LEGEND.TODAY_WORKING_HOURS.DESCRIPTION"
              )}
              icon={<Timeline />}
              backgroundColor={colors.green[50]}
            />{" "}
            <LegendComponent
              title={t("DASHBOARD.LEGEND.TOTAL_OVERTIME.TITLE")}
              description={t("DASHBOARD.LEGEND.TOTAL_OVERTIME.DESCRIPTION")}
              icon={<StackedBarChart />}
              backgroundColor={colors.purple[50]}
            />{" "}
            <LegendComponent
              title={t("DASHBOARD.LEGEND.TOTAL_VACATIONS.TITLE")}
              description={t("DASHBOARD.LEGEND.TOTAL_VACATIONS.DESCRIPTION")}
              icon={<AirplanemodeActive />}
              backgroundColor={colors.blue[50]}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button style={{ color: customColors.invert }} onClick={handleClose}>
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalDashboardLegend;
